import React, { useEffect, useState } from "react";
import DataTable, { defaultThemes } from "react-data-table-component";
import {
    ApiGet,
    ApiDelete,
    ApiPut,
    ApiPost,
} from "../../../helpers/API/ApiData";
import { Tooltip } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import List from "@material-ui/core/List";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import { Button } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import Loader from "react-loader-spinner";
import { ToastContainer, toast } from "react-toastify";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const StandardAmenities = ({ getNewCount, title }) => {
    const [amenintiesData, setAmenintiesData] = useState([]);
    const [filteredAmeninties, setFilteredAmeninties] = useState({});
    const [isLoaderVisible, setIsLoaderVisible] = useState(false);
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    //new data
    const [isUpdateAmeninties, setIsUpdateAmeninties] = useState(false);
    const [isAddAmeninties, setIsAddAmeninties] = useState(false);
    const [idForUpdateAmenintiesData, setIdForUpdateAmenintiesData] =
        useState("");
    const [inputValue, setInputValue] = useState({});
    const [inputValueForAdd, setInputValueForAdd] = useState({});
    const [errors, setErrors] = useState({});
    const [errorsForAdd, setErrorsForAdd] = useState({});
    const [idForEditStatus, setIdForEditStatus] = useState("");
    const [idForDeleteAmeninties, setIdForDeleteAmeninties] = useState("");
    const [status, setStatus] = useState("");
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);
    const [countPerPage, setCountPerPage] = useState(10);
    const [search, setSearch] = useState("");

    const handleOnChnage = (e) => {
        const { name, value } = e.target;
        setInputValue({ ...inputValue, [name]: value });
        setErrors({ ...errors, [name]: "" });
    };

    const handleOnChnageAdd = (e) => {
        const { name, value } = e.target;
        setInputValueForAdd({ ...inputValueForAdd, [name]: value });
        setErrorsForAdd({ ...errorsForAdd, [name]: "" });
    };

    useEffect(() => {
        title === "Dashboard | OUR LEISURE HOME" ? document.title = title : document.title = "Standard Amenities | OUR LEISURE HOME"
    }, [])

    const handleAdminUpdateClose = () => {
        setInputValue({});
        setIsUpdateAmeninties(false);
    };

    const handleAddAdminClose = () => {
        setInputValue({});
        setIsAddAmeninties(false);
    };

    const handleClose = () => {
        setShow(false);
    }
    useEffect(() => {
        getAllAmeninties();
    }, [page, countPerPage]);

    const getAllAmeninties = async () => {
        setIsLoaderVisible(true);
        if (!search) {
            await ApiGet(`amenities/getAmenities?type=STANDARD&page=${page}&limit=${countPerPage}`)
                .then((res) => {
                    setIsLoaderVisible(false);
                    setAmenintiesData(res?.data?.payload?.Ameninties);
                    setFilteredAmeninties(res?.data?.payload?.Ameninties);
                    setCount(res?.data?.payload?.count);

                })
                .catch((err) => {
                   toast.error(err);
                });
        } else {
            await ApiGet(`amenities/getAmenities?type=STANDARD&search=${search}&page=${page}&limit=${countPerPage}`)
                .then((res) => {
                    setIsLoaderVisible(false);
                    setAmenintiesData(res?.data?.payload?.Ameninties);
                    setFilteredAmeninties(res?.data?.payload?.Ameninties);
                    setCount(res?.data?.payload?.count);
                })
                .catch((err) => {
                   toast.error(err);
                });
        }

    };

    const validateFormForAddAdmin = () => {
        let formIsValid = true;
        let errorsForAdd = {};
        if (inputValueForAdd && !inputValueForAdd.name) {
            formIsValid = false;
            errorsForAdd["name"] = "*Please Enter Name of Ameninties!";
        }

        setErrorsForAdd(errorsForAdd);
        return formIsValid;
    };

    const handelAddAmenintiesDetails = (e) => {
        e.preventDefault();
        if (validateFormForAddAdmin()) {
            let Data = {
                name: inputValueForAdd.name,
                type: "STANDARD"
            }
            ApiPost(`amenities/addAmenities`, Data)
                .then((res) => {
                    if (res?.status == 200) {
                        setIsAddAmeninties(false);
                        toast.success("Amenintie Added Successfully");
                        setInputValueForAdd({});
                        getAllAmeninties();
                        { document.title === "Dashboard | OUR LEISURE HOME" && getNewCount() }
                    } else {
                        toast.error(res?.data?.message);
                    }
                })
                .catch((err) => {
                    toast.error(err.message);
                });
        }
    };

    const validateForm = () => {
        let formIsValid = true;
        let errors = {};
        if (inputValue && !inputValue.name) {
            formIsValid = false;
            errors["name"] = "*Please Enter Name of Amenintie!";
        }
        setErrors(errors);
        return formIsValid;
    };

    const handleDeleteAmenintie = () => {
        ApiDelete(`amenities/deleteAmenities/${idForDeleteAmeninties}`)
            .then((res) => {
                if (res?.status == 200) {
                    setShow(false);
                    toast.success("Amenintie Deleted Successfully");
                    getAllAmeninties();
                    { document.title === "Dashboard | OUR LEISURE HOME" && getNewCount() }
                    setPage(1)
                    setCount(0)
                    setCountPerPage(countPerPage)
                } else {
                    toast.error(res?.data?.message);
                }
            })
            .catch((err) => {
                toast.error(err.message);
            });
    };


    const handelUpdateAmenintieDetails = (e) => {
        e.preventDefault();
        if (validateForm()) {
            ApiPut(`amenities/updateAmenities/${idForUpdateAmenintiesData}`, inputValue)
                .then((res) => {
                    if (res?.status == 200) {
                        setIsUpdateAmeninties(false);
                        toast.success("Data updated Successfully");
                        setInputValue({});
                        getAllAmeninties();
                    } else {
                        toast.error(res?.data?.message);
                    }
                })
                .catch((err) => {
                    toast.error(err.message);
                });
        }
    };

    let i = 0;
    const columns = [
        {
            name: "SNo",
            cell: (row, index) => (page - 1) * countPerPage + (index + 1),
            width: "65px",
        },
        {
            name: "Name",
            selector: "name",
            sortable: true,
        },
        {
            name: "Type",
            selector: "type",
            sortable: true,
        },
        {
            name: "Actions",
            cell: (row) => {
                return (
                    <>
                        <div className="d-flex justify-content-between">
                            <div
                                className="cursor-pointer pl-2"
                                onClick={() => {
                                    setIsUpdateAmeninties(true);
                                    setIdForUpdateAmenintiesData(row._id);
                                    setInputValue({
                                        name: row?.name,
                                    });
                                }}
                            >
                                <Tooltip title="Edit Amenintie" arrow>
                                    <CreateIcon />
                                </Tooltip>
                            </div>
                        </div>
                        <div
                            className="cursor-pointer"
                            onClick={() => {
                                setShow(true)
                                setIdForDeleteAmeninties(row?._id)
                            }}
                        >
                            <Tooltip title="Delete Ameninties" arrow>
                                <DeleteIcon />
                            </Tooltip>
                        </div>
                    </>
                );
            },
        },
    ];
    // * Table Style
    const customStyles = {
        header: {
            style: {
                minHeight: "56px",
            },
        },
        headRow: {
            style: {
                borderTopStyle: "solid",
                borderTopWidth: "1px",
                borderTopColor: defaultThemes.default.divider.default,
            },
        },
        headCells: {
            style: {
                "&:not(:last-of-type)": {
                    borderRightStyle: "solid",
                    borderRightWidth: "1px",
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
        cells: {
            style: {
                "&:not(:last-of-type)": {
                    borderRightStyle: "solid",
                    borderRightWidth: "1px",
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
    };

    //for search data

    const handleSearch = (e) => {
        setSearch(e.target.value)
    };

    const debouncedSearchTerm = useDebounce(search, 500);

    // Hook
    function useDebounce(value, delay) {
        // State and setters for debounced value
        const [debouncedValue, setDebouncedValue] = useState(value);
        useEffect(
            () => {
                // Update debounced value after delay
                const handler = setTimeout(() => {
                    setDebouncedValue(value);
                }, delay);
                // Cancel the timeout if value changes (also on delay change or unmount)
                // This is how we prevent debounced value from updating if value is changed ...
                // .. within the delay period. Timeout gets cleared and restarted.
                return () => {
                    clearTimeout(handler);
                };
            },
            [value, delay] // Only re-call effect if value or delay changes
        );
        return debouncedValue;
    }

    useEffect(() => {
        if (debouncedSearchTerm) {
            setIsLoaderVisible(true);
            setPage(1)
            setCount(0)
            setCountPerPage(countPerPage)
            getAllAmeninties();

        } else {
            setPage(1)
            setCount(0)
            setCountPerPage(countPerPage)
            getAllAmeninties();
        }
    }, [debouncedSearchTerm]);


    return (
        <>
            <div className="card p-1">
                {document.title === "Standard Amenities | OUR LEISURE HOME" && <ToastContainer />}
                <div className="p-2 mb-2">
                    <div className="row mb-4 pr-3">
                        <div className="col-md-3 col-sm-12 d-flex justify-content-between">
                            <h2 className="pl-3 pt-2">Standard Amenities</h2>
                        </div>
                        <div className="col-md-7 col-sm-12 mobile-view-align">
                            <div>
                                <input
                                    type="text"
                                    className={`form-control form-control-lg form-control-solid `}
                                    name="title"
                                    placeholder="Search Standard Amenities"
                                    onChange={(e) => handleSearch(e)}
                                />
                            </div>
                        </div>
                        <div className="col-md-2 cus-medium-button-style mobile-view-align mobile-button-center-align button-height">
                        <button
                            onClick={() => {
                                setIsAddAmeninties(true);
                            }}
                        >
                            Add Standard Amenities
                        </button>
                        </div>
                    </div>

                    {/* delete model */}
                    <Modal show={show} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title className="text-danger">Alert!</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are You Sure To Want To{" "} delete this Amenintie
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Cancel
                            </Button>
                            <Button
                                variant="danger"
                                onClick={() => {
                                    handleDeleteAmenintie();
                                }}
                            >
                                Delete
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    {/* end delete model */}

                    <DataTable
                        columns={columns}
                        data={filteredAmeninties}
                        customStyles={customStyles}
                        style={{
                            marginTop: "-3rem",
                        }}
                        progressPending={isLoaderVisible}
                        progressComponent={
                            <Loader type="Puff" color="#334D52" height={30} width={30} />
                        }
                        highlightOnHover
                        pagination
                        paginationServer
                        paginationTotalRows={count}
                        paginationPerPage={countPerPage}
                        paginationRowsPerPageOptions={[10, 20, 25, 50, 100]}
                        paginationDefaultPage={page}
                        onChangePage={(page) => {
                            setPage(page);
                        }}
                        onChangeRowsPerPage={(rowPerPage) => {
                            setCountPerPage(rowPerPage);
                        }}
                    />
                </div>
            </div>

            {isAddAmeninties ? (
                <Dialog
                    fullScreen
                    open={isAddAmeninties}
                    onClose={handleAddAdminClose}
                    TransitionComponent={Transition}
                >
                    {/* <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleAddAdminClose}
                            aria-label="close"
                            style={{ width: '100%', justifyContent: 'flex-end' }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar> */}
                    <div className="cus-modal-close" onClick={handleAddAdminClose}>
                        <CloseIcon />
                    </div>
                    <List>
                        {isAddAmeninties === true ? (
                            <div className="form full-container">
                                {/* Name Amenintie */}
                                <div className="form-group row">
                                    <label className="col-xl-3 col-lg-3 col-form-label">
                                        Amenintie Name
                                    </label>
                                    <div className="col-lg-9 col-xl-6">
                                        <div>
                                            <input
                                                type="text"
                                                className={`form-control form-control-lg form-control-solid `}
                                                id="name"
                                                name="name"
                                                value={inputValueForAdd.name}
                                                onChange={(e) => {
                                                    handleOnChnageAdd(e);
                                                }}
                                            />
                                        </div>
                                        <span
                                            style={{
                                                color: "red",
                                                top: "5px",
                                                fontSize: "12px",
                                            }}
                                        >
                                            {errorsForAdd["name"]}
                                        </span>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center justify-content-center">
                                    <button
                                        onClick={(e) => {
                                            handelAddAmenintiesDetails(e);
                                        }}
                                        className="btn btn-success mr-2"
                                    >
                                        <span>Add Details</span>
                                        {loading && (
                                            <span className="mx-3 spinner spinner-white"></span>
                                        )}
                                    </button>
                                </div>
                            </div>
                        ) : null}
                    </List>
                </Dialog>
            ) : null}

            {isUpdateAmeninties ? (
                <Dialog
                    fullScreen
                    open={isUpdateAmeninties}
                    onClose={handleAdminUpdateClose}
                    TransitionComponent={Transition}
                >
                    <div className="cus-modal-close" onClick={handleAdminUpdateClose}>
                        <CloseIcon />
                    </div>
                    <List>
                        {isUpdateAmeninties === true ? (
                            <div className="full-container">
                                {/* Ameninties Name */}
                                <div className="form-group row">
                                    <label className="col-xl-3 col-lg-3 col-form-label">
                                        Amenintie Name
                                    </label>
                                    <div className="col-lg-9 col-xl-6">
                                        <div>
                                            <input
                                                type="text"
                                                className={`form-control form-control-lg form-control-solid `}
                                                id="name"
                                                name="name"
                                                value={inputValue.name}
                                                onChange={(e) => {
                                                    handleOnChnage(e);
                                                }}
                                            />
                                        </div>
                                        <span
                                            style={{
                                                color: "red",
                                                top: "5px",
                                                fontSize: "12px",
                                            }}
                                        >
                                            {errors["name"]}
                                        </span>
                                    </div>
                                </div>


                                <div className="d-flex align-items-center justify-content-center">
                                    <button
                                        onClick={(e) => {
                                            handelUpdateAmenintieDetails(e);
                                        }}
                                        className="btn btn-success mr-2"
                                    >
                                        <span>Update Details</span>
                                        {loading && (
                                            <span className="mx-3 spinner spinner-white"></span>
                                        )}
                                    </button>
                                </div>
                            </div>
                        ) : null}
                    </List>
                </Dialog>
            ) : null}
        </>
    );
};

export default StandardAmenities;
